import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { ITINERARY_SUPPLIER_FOOD_PATH } from '../../../../config/paths';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import ItinerarySupplierFoodBasicInformationResource from './resource/ItinerarySupplierFoodBasicInformationResource';
import {
  clearItinerarySupplierFood,
  getItinerarySupplierFood,
} from '../../../../actions/food/ItinerarySupplierFood';
import ItinerarySupplierFoodToolbar from './ItinerarySupplierFoodToolbar';

export const ItinerarySupplierFood = ({
  breadcrumbs,
  dispatchGetItinerarySupplierFood,
  dispatchClearItinerarySupplierFood,
  match: {
    params: { id: itinerarySupplierFoodId },
  },
  loading,
  itinerarySupplierFood,
}) => {
  useLayoutEffect(() => {
    dispatchGetItinerarySupplierFood({ itinerarySupplierFoodId });

    return () => dispatchClearItinerarySupplierFood();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (itinerarySupplierFood.isEmpty())
    content = <NoDataResource returnPage={ITINERARY_SUPPLIER_FOOD_PATH} />;
  else {
    const itinerarySupplierFoodJson = itinerarySupplierFood.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <ItinerarySupplierFoodBasicInformationResource
          {...itinerarySupplierFoodJson}
        />
      </>
    );

    toolbar = (
      <ItinerarySupplierFoodToolbar
        itinerarySupplierFood={itinerarySupplierFoodJson}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Alimentación de Proveedor por Itinerario"
      content={content}
      toolbar={toolbar}
    />
  );
};

ItinerarySupplierFood.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearItinerarySupplierFood: PropTypes.func.isRequired,
  dispatchGetItinerarySupplierFood: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  itinerarySupplierFood: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ItinerarySupplierFood.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearItinerarySupplierFood: clearItinerarySupplierFood,
  dispatchGetItinerarySupplierFood: getItinerarySupplierFood,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Alimentaciones por Proveedor',
      href: ITINERARY_SUPPLIER_FOOD_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  itinerarySupplierFood: FoodUnit.ItinerarySupplierFood.getIn([
    'current',
    'content',
  ]),
  loading: !FoodUnit.ItinerarySupplierFood.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItinerarySupplierFood);
